import { Clients } from 'src/models/clients';

export const getClients = async (): Promise<Clients> => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/data/clients`, {
      method: 'GET'
    });
    const data = await response.json();
    if (response.ok) {
      return data;
    } else {
      console.log('Error fetching users', data);
    }
  } catch (e) {
    console.log('Error fetching users', e);
  }
};
